module.exports = __webpack_public_path__ + "static/media/sample.76edad67.jpeg";